// @ts-strict-ignore
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { ChannelAddress, CurrentData, Utils } from "src/app/shared/shared";

@Component({
    selector: "selfconsumptionWidget",
    templateUrl: "./flat.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FlatComponent extends AbstractFlatWidget {
    protected selfconsumptionValue: number | null;
    /**
     * Ob diese Edge einen echten Netz-Zähler hat - ohne Zähler ist
     * Eigennutzung nicht sinnvoll berechenbar. Siehe
     * [[project_excello_teuschnitz_pv_monitoring]].
     */
    protected hasGridMeter: boolean = true;

    protected override afterIsInitialized(): void {
        this.hasGridMeter = this.config
            ?.getComponentsImplementingNature("io.openems.edge.meter.api.ElectricityMeter")
            .some(c => c.isEnabled && this.config.isTypeGrid(c)) ?? true;
    }

    protected override onCurrentData(currentData: CurrentData) {
        this.selfconsumptionValue = this.hasGridMeter
            ? Utils.calculateSelfConsumption(
                currentData.allComponents["_sum/GridSellActiveEnergy"],
                currentData.allComponents["_sum/ProductionActiveEnergy"],
            )
            : null;
    }

    protected override getChannelAddresses(): ChannelAddress[] {
        return [
            new ChannelAddress("_sum", "GridSellActiveEnergy"),
            new ChannelAddress("_sum", "ProductionActiveEnergy"),
        ];
    }
}
